/**
 * Referentiels
 */

import { CashRegisterTransactionType } from '@services/dtos/AccountingV2Dto'
import {
  ActivityLevel,
  CompoundProductionStepType,
  CompoundType,
  CustomQualityControlType,
  DunningNoticeLevel,
  EventEnum,
  HotLabEquipmentType,
  IsotopeEmissionType,
  IsotopeUsage,
  MonitoringMethod,
  MssRequestPriority,
  MssRequestStatus,
  PaymentModeType,
  PosologyPatientType,
  PosologySliceType,
  PreparationStatus,
  QualityControlStatus,
  PrescriptionStatus,
  ProductOrderCancellationReason,
  ProductOrderPaymentStatus,
  ProductOrderStatus,
  ProductType,
  Side,
  StockReason,
  StorageType,
  SupplierContactType,
  SupplierPaymentMethod,
  SupplierType,
  VisualQualityControlType,
  WasteStatus,
  WasteType,
} from '@services/dtos'
import { FileTypeEnum } from '../common/interfaces'
import { MemberRoleEnum } from '@services/api'
import { CardType } from '@state/reducers/appReducer'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import CancelIcon from '@mui/icons-material/Cancel'
import AdjustIcon from '@mui/icons-material/Adjust'
import PendingActionsIcon from '@mui/icons-material/PendingActions'
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges'
import { PatientContactRelationship } from '@services/patientContactService'
import {
  DoDisturb,
  ForwardToInbox,
  Unsubscribe,
  OfflinePin,
  HourglassEmpty,
  Paid,
} from '@mui/icons-material'
import { ReportDictationMode } from '@services/MemberPreferenceConfigService'
import { WasteEntrySource } from '@/services/wasteEntryService'

export type GenderType =
  | 'MALE'
  | 'FEMALE'
  | 'TRANSGENDERMALETOFEMALE'
  | 'TRANSGENDERFEMALETOMALE'
  | 'OTHER'
  | 'UNREPORTED'

export const studySharingExpirations = [
  { value: 0, label: 'No Expiration' },
  { value: 1, label: '1 week' },
  { value: 2, label: '2 weeks' },
  { value: 3, label: '3 weeks' },
  { value: 4, label: '1 month' },
  { value: 8, label: '2 month' },
]

export const studySharingPermissions = [
  { value: 'VIEW', label: 'View' },
  { value: 'VIEW_AND_REPORT', label: 'View and Report' },
  { value: 'EXPORT', label: 'Export' },
]

export const sex = [
  { value: '', label: 'All' },
  { value: 'F', label: 'Female' },
  { value: 'M', label: 'Male' },
  { value: 'O', label: 'Other' },
  { value: 'U', label: 'Unknown' },
]

export const scannerStudy = [
  { value: '', label: '' },
  { value: 'scanner', label: 'Scanner' },
  { value: 'coloscanner', label: 'Coloscanner' },
  { value: 'arthroscanner', label: 'Arthroscanner' },
  { value: 'angioscan', label: 'Angioscan' },
  { value: 'uroscanner', label: 'Uroscanner' },
  { value: 'infiltration', label: 'Infiltration' },
  { value: 'uroscanner', label: 'Uroscanner' },
  { value: 'orl', label: 'ORL' },
]

export const bodyPart = [
  { value: '', label: 'all' },
  { value: 'cerebral', label: 'cerebral' },
  { value: 'crane', label: 'crane' },
  { value: 'bassin', label: 'bassin' },
  { value: 'cheville', label: 'cheville' },
  { value: 'coude', label: 'coude' },
  { value: 'de la face', label: 'de la face' },
  { value: 'epaule', label: 'epaule' },
  { value: 'genou', label: 'genou' },
  { value: 'hanche', label: 'hanche' },
  { value: 'jambe', label: 'jambe' },
  { value: 'main', label: 'main' },
  { value: 'maxillaire', label: 'maxillaire' },
  { value: 'pelvimetrie', label: 'pelvimetrie' },
  { value: 'pied', label: 'pied' },
  { value: 'poignet', label: 'poignet' },
  { value: 'rachis cervical', label: 'rachis cervical' },
  { value: 'rachis dorsal', label: 'rachis dorsal' },
  { value: 'rachis lombaire', label: 'rachis lombaire' },
  { value: 'sinus', label: 'sinus' },
  { value: 'thoracique', label: 'thoracique' },
  { value: 'abdomino-pelvienne', label: 'abdomino-pelvienne' },
  { value: 'thoraco-abdomino-pelvien', label: 'thoraco-abdomino-pelvien' },
  { value: 'poignet', label: 'poignet' },
]

export const siteType = [
  { value: '', label: 'All' },
  { value: '101', label: 'Centre Hospitalier Régional (C.H.R.)' },
  { value: '114', label: 'Hôpital des armées' },
  { value: '128', label: 'Etablissement de Soins Chirurgicaux' },
  { value: '129', label: 'Etablissement de Soins Médicaux' },
  { value: '131', label: 'Centre de Lutte Contre Cancer' },
  {
    value: '292',
    label: 'Centre Hospitalier Spécialisé lutte Maladies Mentales',
  },
  { value: '355', label: 'Centre Hospitalier (C.H.)' },
  { value: '365', label: 'Etablissement de Soins Pluridisciplinaire' },
  { value: '696', label: 'Groupement de coopération sanitaire de moyens' },
  {
    value: '697',
    label: 'Groupement de coopération sanitaire - Etablissement de santé',
  },
  { value: '698', label: 'Autre Etablissement Loi Hospitalière' },
  { value: '699', label: 'Entité Ayant Autorisation' },
]

export const legalStatus = [
  { value: '', label: 'All' },
  { value: '1', label: 'Etat' },
  { value: '10', label: 'Etablissement Public National d\'Hospitalisation' },
  {
    value: '11',
    label: 'Etablissement Public Départemental d\'Hospitalisation',
  },
  { value: '13', label: 'Etablissement Public Communal d\'Hospitalisation' },
  {
    value: '14',
    label: 'Etablissement Public Intercommunal d\'Hospitalisation',
  },
  { value: '15', label: 'Etablissement Public Régional d\'Hospitalisation' },
  {
    value: '27',
    label: 'Etablissement Public à Caractère Industriel ou Commercial',
  },
  { value: '29', label: 'Groupement de Coopération Sanitaire public' },
  { value: '44', label: 'Régime Maladie des non Salariés non Agricole' },
  { value: '47', label: 'Société Mutualiste' },
  { value: '49', label: 'Autre Organisme Mutualiste' },
  {
    value: '60',
    label: 'Association Loi 1901 non Reconnue d\'Utilité Publique',
  },
  { value: '61', label: 'Association Loi 1901 Reconnue d\'Utilité Publique' },
  { value: '62', label: 'Association de Droit Local' },
  { value: '63', label: 'Fondation' },
  { value: '64', label: 'Congrégation' },
  { value: '65', label: 'Autre Organisme Privé à But non Lucratif' },
  { value: '70', label: 'Personne Physique' },
  { value: '72', label: 'Société A Responsabilité Limitée (S.A.R.L.)' },
  { value: '73', label: 'Société Anonyme (S.A.)' },
  { value: '74', label: 'Société Civile' },
  { value: '75', label: 'Autre Société' },
  { value: '76', label: 'Groupement d\'Intérêt Economique (G.I.E.)' },
  { value: '77', label: 'Autre Organisme Privé à Caractère Commercial' },
  {
    value: '78',
    label: 'Entreprise Unipersonnelle Responsabilité Limitée (E.U.R.L.)',
  },
  { value: '79', label: 'Société Civile de Moyens (S.C.M.)' },
  {
    value: '85',
    label: 'Soc. Exercice Libéral Responsabilité Limitée (S.E.L.A.R.L.)',
  },
  { value: '88', label: 'Société Civile Professionnelle (S.C.P.)' },
  { value: '89', label: 'Groupement de Coopération Sanitaire Privéete' },
  {
    value: '91',
    label: 'Société Exercice Libéral par Actions Simplifiée (S.E.L.A.S.)',
  },
  { value: '95', label: 'Société par Actions Simplifiée (S.A.S.)' },
]

// ***************** Exams *****************
export const examDuration = [
  { value: 5, label: '5 min' },
  { value: 10, label: '10 min' },
  { value: 15, label: '15 min' },
  { value: 20, label: '20 min' },
  { value: 25, label: '25 min' },
  { value: 30, label: '30 min' },
  { value: 45, label: '45 min' },
  { value: 60, label: '1h' },
]
// *****************STAFF position*****************
// ***************** Job list *****************
export const memberJob = [
  { value: 'healthExecutive', label: 'Health Executive' },
  { value: 'executiveDirecto', label: 'Executive Directo' },
  { value: 'financeDirector', label: 'Finance Director' },
  { value: 'accountant', label: 'Accountant' },
  { value: 'computerTechnician', label: 'Computer Technician' },
  { value: 'security', label: 'Security' },
  { value: 'RSSI', label: 'RSSI' },
  { value: 'DSI', label: 'DSI' },
  { value: 'secretary', label: 'Secretary' },
  { value: 'radiographer', label: 'Radiographer' },
  { value: 'serviceProvider', label: 'Service Provider' },
  { value: 'ITProvider', label: 'ITProvider' },
  { value: 'manager', label: 'Manager' },
  { value: 'radiologist', label: 'Radiologist' },
  { value: 'headRadiology', label: 'Head of Radiology' },
  { value: 'qualityManager', label: 'Quality Manager' },
  { value: 'headEmergencies', label: 'Head of Emergencies' },
  { value: 'biomedicalEngineer', label: 'Biomedical Engineer' },
]

// ***************** Medical Imaging Specialities *****************\
export const radiologistSpecialities = [
  { value: '1', label: 'Oncology' },
  { value: '2', label: 'Pediatric' },
  { value: '3', label: 'MRI MSK' },
  { value: '4', label: 'Neuro Radio' },
  { value: '5', label: 'Vascular' },
  { value: '6', label: 'CT' },
  { value: '7', label: 'MRI' },
  { value: '8', label: 'Conventional radiology' },
]

export const medicalImagingSpecialities = [
  { value: '1', label: 'Conventional Radiology' },
  { value: '2', label: 'CT' },
  { value: '3', label: 'MR' },
  { value: '4', label: 'MG' },
  { value: '5', label: 'US' },
  { value: '6', label: 'CR-Dx' },
  { value: '7', label: 'NM' },
  { value: '8', label: 'PET' },
]

// *********** CHARTS ************

export const chartActivitySelect = [
  { value: '1', label: 'Number of Studies' },
  { value: '2', label: 'Top list of Refering physician' },
  { value: '3', label: 'Top list of Portal user' },
  { value: '4', label: 'Studies per modality' },
  { value: '5', label: '% of Studies booked Online' },
  { value: '6', label: '% of Studies with Admission' },
  { value: '7', label: 'Volume of Data Sent by customer' },
]

export const chartSecuritySelect = [
  { value: '1', label: 'Accounts unlocked' },
  { value: '2', label: 'Accounts login from different IP' },
  { value: '3', label: 'Prescritpion and Studies linked with deprecated RPPS' },
  {
    value: '4',
    label: 'Prescription and Studies linked with Doctors* without RPPS',
  },
]

export const chartPerformanceSelect = [
  { value: '1', label: 'Report Validattion Time(*acquisition)' },
  { value: '2', label: 'Transfer Local Time ' },
  { value: '3', label: 'Transfer Cloud Time' },
  { value: '4', label: 'Transfer Time' },
  { value: '5', label: 'Report Validation Time (*reception)' },
  { value: '6', label: 'Protocol Generation' },
  { value: '7', label: 'Rejected Studies (because of low quality)' },
  { value: '8', label: 'Number of Studies' },
]

export const chartSelectTop_10_100 = [
  { value: '1', label: '10' },
  { value: '2', label: '50' },
  { value: '3', label: '100' },
]

export const chartSelectTop_20_100 = [
  { value: '1', label: '20' },
  { value: '2', label: '50' },
  { value: '3', label: '100' },
]

export const chartSelectTelemedecine = [
  { value: '1', label: 'Xray' },
  { value: '2', label: 'CT' },
  { value: '3', label: 'MR' },
  { value: '3', label: 'CT + MR' },
]

// ***************** EQUIPMENTS *****************
// ***************** IT Equipment List *****************

export const itEquipmentType = [
  { value: '', label: 'All' },
  { value: 'server', label: 'Server' },
  { value: 'vpn', label: 'VPN' },
  { value: 'router', label: 'Router' },
  { value: 'switch', label: 'Switch' },
  { value: 'tv', label: 'TV' },
  { value: 'other', label: 'Other' },
]
// ***************** Medical Equipment List *****************

export const medicalEquipmentType = [
  { value: 'CP', label: 'Capteur plan' },
  { value: 'US', label: 'Echographe' },
  { value: 'EOS', label: 'EOS' },
  { value: 'NM', label: 'Gamma Camera' },
  { value: 'MR', label: 'IRM' },
  { value: 'LINAC', label: 'Linac' },
  { value: 'MG', label: 'Mammographe' },
  { value: 'BDUS', label: 'Osteodentisometre (ultrasound)' },
  { value: 'BMD', label: 'Osteodentisometre (X-Ray)' },
  { value: 'OT', label: 'Other' },
  { value: 'PT', label: 'PET Scan' },
  { value: 'RCT', label: 'Remote controlled table' },
  { value: 'CT', label: 'Scanner' },
]

// ***************** Manufacturer List *****************
export const equipmentBrand = [
  { value: '', label: 'All' },
  { value: 'canon', label: 'Canon' },
  { value: 'cyberknife', label: 'CyberKnife' },
  { value: 'dms-appelem', label: 'DMS / Appelem' },
  { value: 'dms', label: 'DMS' },
  { value: 'elekta', label: 'Elekta' },
  { value: 'eos', label: 'EOS' },
  { value: 'fona', label: 'Fona' },
  { value: 'fuji', label: 'FujiFilm' },
  { value: 'giotto', label: 'Giotto' },
  { value: 'ge', label: 'General Electric' },
  { value: 'gmm', label: 'GMM' },
  { value: 'hitachi-fuji', label: 'Hitachi / FujiFilm' },
  { value: 'hologic', label: 'Hologic' },
  { value: 'mindray', label: 'Mindray' },
  { value: 'neuesoft', label: 'NeueSoft' },
  { value: 'philips', label: 'Philips' },
  { value: 'samsung-emdison', label: 'Samsung / Medison' },
  { value: 'sectra', label: 'Sectra' },
  { value: 'siemens', label: 'Siemens' },
  { value: 'sirona', label: 'Sirona' },
  { value: 'spectrum-dynamic', label: 'Spectrum Dynamic' },
  { value: 'stephanix', label: 'Stephanix' },
  { value: 'tomotherapy', label: 'Tomotherapy' },
  { value: 'carestream', label: 'Carestream' },
  { value: 'newtom', label: 'NewTom' },
  { value: 'varian', label: 'Varian' },
]

// ***************** Equipment Model list *****************
// ***************** Scanners *****************
export const EOSModel = [
  { value: '1', label: 'EOS Edge' },
  { value: '2', label: 'EOS System' },
]

export const scannerModelGE = [
  { value: '1', label: 'Revolution Apex' },
  { value: '2', label: 'Revolution Frontier' },
  { value: '3', label: 'Revolution ACT' },
  { value: '4', label: 'Revolution HD' },
  { value: '5', label: 'Optima' },
  { value: '6', label: 'Discovery RT' },
  { value: '7', label: 'Other' },
]

export const scannerModelSiemens = [
  { value: '1', label: 'Somatom Force' },
  { value: '2', label: 'Somatom Drive' },
  { value: '3', label: 'Somatom X-Cite' },
  { value: '4', label: 'Somatom Edge Plus' },
  { value: '5', label: 'Somatom Definition' },
  { value: '6', label: 'Other' },
]

export const scannerModelCanon = [
  { value: '1', label: 'Aquilion ONE' },
  { value: '2', label: 'Aquilion Prime' },
  { value: '3', label: 'Aquilion Lightning' },
  { value: '4', label: 'Aquilion Exceed' },
  { value: '5', label: 'Aquilion LB' },
  { value: '6', label: 'Other' },
]

export const scannerModelPhilips = [
  { value: '1', label: 'IQon' },
  { value: '2', label: 'Incisive CT' },
  { value: '3', label: 'Ingenuity' },
  { value: '4', label: 'MX16evo' },
  { value: '5', label: 'Other' },
]

export const IRMModelGE = [
  { value: '1', label: 'Signa Explorer' },
  { value: '2', label: 'Signa Voyager' },
  { value: '3', label: 'Signa Architect Air 3T' },
  { value: '4', label: 'Signa Premier Air 3T' },
  { value: '5', label: 'Signa Pioneer 3T' },
  { value: '6', label: 'Signa Discovery 3T' },
  { value: '7', label: 'Other' },
]

// ***************** IRM *****************
export const IRMModelSiemens = [
  { value: '1', label: 'Magnetom Sola' },
  { value: '2', label: 'Magnetom Altea' },
  { value: '3', label: 'Magnetom Sempra' },
  { value: '4', label: 'Magnetom Vida 3T' },
  { value: '5', label: 'Magnetom Lumina 3T' },
  { value: '6', label: 'Prisma 3T' },
  { value: '7', label: 'Other' },
]

export const IRMModelCanon = [
  { value: '1', label: 'Vantage Galan 3T' },
  { value: '2', label: 'Vantage Orian' },
  { value: '3', label: 'Vantage Elan' },
  { value: '4', label: 'Vantage Elan Osteo' },
  { value: '5', label: 'Other' },
]

export const IRMModelPhilips = [
  { value: '1', label: 'Ingenia Edition' },
  { value: '2', label: 'Ingenia Ambition' },
  { value: '3', label: 'Other' },
]

// ***************** Mammoograph *****************
export const mamoModelGE = [
  { value: '1', label: 'Pristina' },
  { value: '2', label: 'Serena' },
  { value: '3', label: 'Crystal Nova' },
  { value: '4', label: 'Other' },
]

export const mamoModelSiemens = [
  { value: '1', label: 'Mammomat Revelation' },
  { value: '2', label: 'Mammomat Inspiration' },
  { value: '3', label: 'Mammomat Fusion' },
  { value: '4', label: 'Other' },
]

export const mamoModelFuji = [
  { value: '1', label: 'Amulet' },
  { value: '2', label: 'Innovality' },
  { value: '3', label: 'Other' },
]

export const mamoModelHologic = [
  { value: '1', label: '3Dimension' },
  { value: '2', label: 'Selenia' },
  { value: '3', label: 'Other' },
]

export const mamoModelGiotto = [
  { value: '1', label: '3000' },
  { value: '2', label: '4000' },
  { value: '3', label: 'Other' },
]

// ***************** Echograph *****************
export const echoModelSamsung = [
  { value: '1', label: 'RS85A Prestige' },
  { value: '2', label: 'HS70A' },
  { value: '3', label: 'HM70A' },
  { value: '4', label: 'Other' },
]

export const echoModelToshiba = [
  { value: '1', label: 'Applio i' },
  { value: '2', label: 'Applio a' },
  { value: '3', label: 'Applio 400' },
  { value: '4', label: 'Applio 500' },
  { value: '5', label: 'XarioViamo' },
  { value: '6', label: 'Other' },
]

export const echoModelHitachi = [
  { value: '1', label: 'Arietta' },
  { value: '2', label: 'Lisendo' },
  { value: '3', label: 'Other' },
]

export const echoModelSiemens = [
  { value: '1', label: 'Acuson Sequoia' },
  { value: '2', label: 'Acuson Juniper' },
  { value: '3', label: 'Acuson Redwood' },
  { value: '4', label: 'Acuson NX2' },
  { value: '5', label: 'Acuson NX3' },
  { value: '6', label: 'Other' },
]

export const echoModelPhilips = [
  { value: '1', label: 'Eqip Elite' },
  { value: '2', label: 'Eqip CVX' },
  { value: '3', label: 'Lumify' },
  { value: '4', label: 'Affinity 30/50/70' },
  { value: '5', label: 'CX50' },
  { value: '6', label: 'InnoSight' },
  { value: '7', label: 'ClearVue850' },
  { value: '8', label: 'Other' },
]

export const echoModelSuperSonic = [
  { value: '1', label: 'Mach 20' },
  { value: '2', label: 'Mach30' },
  { value: '3', label: 'AirExplorer' },
  { value: '4', label: 'AirExplorer Ultimate' },
  { value: '5', label: 'Other' },
]

// ***************** Equipment Specs list *****************
export const scannerBarrettes = [
  { value: '1', label: '4' },
  { value: '2', label: '8' },
  { value: '3', label: '16' },
  { value: '4', label: '32' },
  { value: '5', label: '40' },
  { value: '6', label: '64' },
  { value: '7', label: '128' },
  { value: '8', label: '192' },
  { value: '9', label: '192+' },
]

export const linacTps = [
  { value: '1', label: 'Eclipse' },
  { value: '2', label: 'Isogray' },
  { value: '3', label: 'Monaco' },
  { value: '4', label: 'XIO' },
  { value: '5', label: 'Pinnacle' },
  { value: '6', label: 'BrainLab' },
]

export const oncologyInformationSystem = [
  { value: '1', label: 'Aria' },
  { value: '2', label: 'Mosaiq' },
]

// Components ressources
// Mui color components
export const colors = [
  { color: 'blue', hex: '#72adf0' },
  { color: 'brown', hex: '#8d7968' },
  { color: 'green', hex: '#8be68b' },
  { color: 'grey', hex: '#aaaaaa' },
  { color: 'orange', hex: '#e6c485' },
  { color: 'pink', hex: '#f7bcc6' },
  { color: 'purple', hex: '#b270d8' },
  { color: 'red', hex: '#ff7979' },
  { color: 'teal', hex: '#7cd8d8' },
  { color: 'yellow', hex: '#e4e49e' },
]

// Preferences menu
// TODO get from backend
export const patientCallDuration = [
  { value: 1, label: '5s' },
  { value: 2, label: '10s' },
  { value: 3, label: '15s' },
  { value: 4, label: '20s' },
  { value: 5, label: '30s' },
]
export const patientScrollSpeed = [
  { value: 1, label: 'slow' },
  { value: 2, label: 'normal' },
  { value: 3, label: 'fast' },
  { value: 4, label: 'very fast' },
]

export const defaultList = [
  { value: '1', label: 'Choix 1' },
  { value: '2', label: 'Choix 2' },
  { value: '3', label: 'Choix 3' },
  { value: '4', label: 'Choix 4' },
]

export const questionType = [
  { value: 'OPEN', label: 'Open' },
  { value: 'CLOSED', label: 'Close' },
  { value: 'DATE', label: 'Date' },
  { value: 'CHOICES', label: 'Choices' },
  { value: 'MULTICHOICES', label: 'Multi Choices' },
]

export const vitalResponseMock: any = {
  idJfse: 1,
  integrator: {
    name: 'TheraSoft',
    key: 'TsXcare',
    etablissement: '',
    os: 'WINDOWS',
  },
  cardReader: {
    id: 'cc379099-d05d-446c-a9c6-edc41be7a966',
    protocol: 'PSS',
    channel: '0',
    reader: '0',
    vitale: '',
    cps: '',
  },
  returnMode: {
    mode: 1,
    URL: '',
  },
  method: {
    name: 'DVF-gui-choix/beneficiaire',
    service: false,
    parameters: {
      redirect: false,
      cv: {
        donneescv: {
          groupe: 101,
          mode131: 0,
          noBeneficiaireSelectionne: 0,
          type: 'T',
          numeroSerie: '58666419',
          dateFinValidite: '20251231',
          donneesAdministrationRUF1: '0',
          donneesAdministrationRUF2: '',
          donneesAdministration: '',
          typeRUFPorteur: 'A',
          NIR: '1421962965165',
          cleNIR: '96',
          codeRegime: '01',
          caisseGestionnaire: '349',
          centreGestionnaire: '9881',
          codeGestion: '13',
          donneesRUFFamille: '',
          libelleRegime: 'Régime général',
          libelleCaisse: 'Caisse de test',
          libelleGestion: 'Invalides de guerre',
          apCV: 0,
          contexteApCVDetruit: 0,
          serviceAMOFamille: {
            groupe: 102,
            code: '0',
          },
          lstDonneesBeneficiaire: [
            {
              groupe: 104,
              numero: 1,
              nomUsuel: 'ESSAI',
              nomPatronymique: 'ESSAI',
              prenom: 'ALAIN',
              adresse1: '',
              adresse2: 'CNDA',
              adresse3: '515 CHE DU MAS DE ROCHET',
              adresse4: '',
              adresse5: '34170 CASTELNAU LE LEZ',
              NIRCertifie: '',
              cleNIRCertifie: '00',
              dateNaissance: '19421901',
              rangGemellaire: '1',
              qualite: '0',
              libelleQualite: 'Assuré',
              codeServiceAMO: '00',
              dateDebutServiceAMO: '00000000',
              dateFinServiceAMO: '00000000',
              donneesRUFAMO: '',
              INSC: '05000757307370764440',
              cleINSC: '76',
              erreurINSC: 0,
              ACS: 0,
              ACSLibelle: '',
              id: '1721896747121053602',
              lstPeriodeDroitsAMO: [
                {
                  groupe: 105,
                  dateDebut: '20110101',
                  dateFin: '20251231',
                },
              ],
              lstPeriodeCodeCouverture: [
                {
                  groupe: 106,
                  dateFin: '20091003',
                  codeALD: '0',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                },
                {
                  groupe: 106,
                  dateDebut: '20091004',
                  dateFin: '20301231',
                  codeALD: '0',
                  codeSituation: '0101',
                  codeExoStandard: '5',
                  tauxStandard: '100',
                  flagAlsaceMoselle: 0,
                },
                {
                  groupe: 106,
                  dateDebut: '20310101',
                  codeALD: '0',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                },
              ],
            },
            {
              groupe: 104,
              numero: 2,
              nomUsuel: 'ESSAI',
              nomPatronymique: '',
              prenom: 'ALEXANDRE',
              adresse1: '',
              adresse2: '',
              adresse3: '',
              adresse4: '',
              adresse5: '',
              NIRCertifie: '',
              cleNIRCertifie: '00',
              dateNaissance: '20031005',
              rangGemellaire: '1',
              qualite: '6',
              libelleQualite: 'Enfant',
              codeServiceAMO: '00',
              dateDebutServiceAMO: '00000000',
              dateFinServiceAMO: '00000000',
              donneesRUFAMO: '',
              INSC: '',
              cleINSC: '',
              erreurINSC: 3,
              ACS: 0,
              ACSLibelle: '',
              id: '1721896747135053702',
              lstPeriodeDroitsAMO: [
                {
                  groupe: 105,
                  dateDebut: '20110101',
                  dateFin: '20251005',
                },
              ],
              lstPeriodeCodeCouverture: [
                {
                  groupe: 106,
                  codeALD: '0',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                },
              ],
              donneesComplementaire: {
                groupe: 109,
                numeroComplementaireB2: '1100000000',
                numeroComplementaireEDI: '',
                numeroAdherent: '14219629',
                indicateurTraitement: '33',
                dateDebut: '20220101',
                dateFin: '20251005',
                codeRoutage: 'NR',
                identifiantHote: '001',
                nomDomaine: 'RESMUT.TM.FR',
                codeAiguillageSTS: 'M',
                typeServicesAssocies: '',
                servicesAssociesContrat: '',
                libelle: 'Organisme complémentaire n°1100000000',
                lstDonneesRUFComplementaire: [],
              },
            },
            {
              groupe: 104,
              numero: 3,
              nomUsuel: 'ESSAI',
              nomPatronymique: '',
              prenom: 'ALEXIS',
              adresse1: '',
              adresse2: '',
              adresse3: '',
              adresse4: '',
              adresse5: '',
              NIRCertifie: '',
              cleNIRCertifie: '00',
              dateNaissance: '20090904',
              rangGemellaire: '1',
              qualite: '6',
              libelleQualite: 'Enfant',
              codeServiceAMO: '00',
              dateDebutServiceAMO: '00000000',
              dateFinServiceAMO: '00000000',
              donneesRUFAMO: '',
              INSC: '',
              cleINSC: '',
              erreurINSC: 3,
              ACS: 0,
              ACSLibelle: '',
              id: '1721896747161053802',
              lstPeriodeDroitsAMO: [
                {
                  groupe: 105,
                  dateDebut: '20110101',
                  dateFin: '20250904',
                },
              ],
              lstPeriodeCodeCouverture: [
                {
                  groupe: 106,
                  dateFin: '20101019',
                  codeALD: '0',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                },
                {
                  groupe: 106,
                  dateDebut: '20101020',
                  dateFin: '20261231',
                  codeALD: '1',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                  codeExoALD: '4',
                  tauxALD: '100',
                },
                {
                  groupe: 106,
                  dateDebut: '20270101',
                  codeALD: '0',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                },
              ],
              donneesComplementaire: {
                groupe: 109,
                numeroComplementaireB2: '1100000000',
                numeroComplementaireEDI: '',
                numeroAdherent: '14219629',
                indicateurTraitement: '63',
                dateDebut: '20220101',
                dateFin: '20250904',
                codeRoutage: 'NR',
                identifiantHote: '001',
                nomDomaine: 'RESMUT.TM.FR',
                codeAiguillageSTS: 'M',
                typeServicesAssocies: '',
                servicesAssociesContrat: '',
                libelle: 'C2S en gestion séparée - N°1100000000',
                lstDonneesRUFComplementaire: [],
              },
            },
            {
              groupe: 104,
              numero: 4,
              nomUsuel: 'ESSAI',
              nomPatronymique: '',
              prenom: 'AGNES',
              adresse1: '',
              adresse2: '',
              adresse3: '',
              adresse4: '',
              adresse5: '',
              NIRCertifie: '',
              cleNIRCertifie: '00',
              dateNaissance: '20101225',
              rangGemellaire: '1',
              qualite: '6',
              libelleQualite: 'Enfant',
              codeServiceAMO: '00',
              dateDebutServiceAMO: '00000000',
              dateFinServiceAMO: '00000000',
              donneesRUFAMO: '',
              INSC: '',
              cleINSC: '',
              erreurINSC: 3,
              ACS: 0,
              ACSLibelle: '',
              id: '1721896747183053902',
              lstPeriodeDroitsAMO: [
                {
                  groupe: 105,
                  dateDebut: '20110101',
                  dateFin: '20251225',
                },
              ],
              lstPeriodeCodeCouverture: [
                {
                  groupe: 106,
                  dateFin: '20110109',
                  codeALD: '0',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                },
                {
                  groupe: 106,
                  dateDebut: '20110110',
                  dateFin: '20261231',
                  codeALD: '3',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                  codeExoALD: '4',
                  tauxALD: '100',
                },
                {
                  groupe: 106,
                  dateDebut: '20270101',
                  codeALD: '0',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                },
              ],
            },
            {
              groupe: 104,
              numero: 5,
              nomUsuel: 'ESSAI',
              nomPatronymique: '',
              prenom: 'DESIRE',
              adresse1: '',
              adresse2: '',
              adresse3: '',
              adresse4: '',
              adresse5: '',
              NIRCertifie: '',
              cleNIRCertifie: '00',
              dateNaissance: '20181231',
              rangGemellaire: '1',
              qualite: '6',
              libelleQualite: 'Enfant',
              codeServiceAMO: '00',
              dateDebutServiceAMO: '00000000',
              dateFinServiceAMO: '00000000',
              donneesRUFAMO: '',
              INSC: '',
              cleINSC: '',
              erreurINSC: 3,
              ACS: 0,
              ACSLibelle: '',
              id: '1721896747197054002',
              lstPeriodeDroitsAMO: [
                {
                  groupe: 105,
                  dateDebut: '20180101',
                  dateFin: '20251231',
                },
              ],
              lstPeriodeCodeCouverture: [
                {
                  groupe: 106,
                  codeALD: '0',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                },
              ],
              donneesMutuelle: {
                groupe: 107,
                identificationMutuelle: '75900019',
                garantiesEffectives: 'OOOOOOOO',
                indicateurTraitement: '01',
                typeServicesAssocies: '7',
                servicesAssociesContrat: '123456789',
                codeAiguillageSTS: 'R',
                libelle: 'Mutuelle n°75900019',
                lstPeriodeDroitsMutuelle: [
                  {
                    groupe: 108,
                    dateDebut: '20220101',
                    dateFin: '20231231',
                  },
                ],
              },
            },
            {
              groupe: 104,
              numero: 6,
              nomUsuel: 'ESSAI',
              nomPatronymique: '',
              prenom: 'ARTHUR',
              adresse1: '',
              adresse2: '',
              adresse3: '',
              adresse4: '',
              adresse5: '',
              NIRCertifie: '',
              cleNIRCertifie: '00',
              dateNaissance: '20221224',
              rangGemellaire: '1',
              qualite: '6',
              libelleQualite: 'Enfant',
              codeServiceAMO: '00',
              dateDebutServiceAMO: '00000000',
              dateFinServiceAMO: '00000000',
              donneesRUFAMO: '',
              INSC: '',
              cleINSC: '',
              erreurINSC: 3,
              ACS: 0,
              ACSLibelle: '',
              id: '1721896747209054102',
              lstPeriodeDroitsAMO: [
                {
                  groupe: 105,
                  dateDebut: '20221224',
                  dateFin: '20251224',
                },
              ],
              lstPeriodeCodeCouverture: [
                {
                  groupe: 106,
                  codeALD: '0',
                  codeSituation: '0100',
                  flagAlsaceMoselle: 0,
                },
              ],
            },
          ],
        },
      },
    },
    cancel: false,
    output: {
      selection: 1,
    },
  },
}

export enum pathwayhealth {
  'U' = 'Urgence',
  'T' = 'Médecin traitant',
  'N' = 'Nouveau médecin traitant',
  'R' = 'Médecin traitant de substitution',
  'O' = 'Médecin orienté par un médecin traitant',
  'M' = 'Médecin orienté par un autre médecin',
  'J' = 'Généraliste récemment installé',
  'B' = 'Médecin installé en zone sous médicalisée',
  'D' = 'Accès direct spécifique',
  'H' = 'Hors résidence habituelle',
  'S1' = 'Hors accès spécifique',
  'S2' = 'Non-respect du parcours / autre médecin',
}

export const parcourSoinsOptions = [
  { value: 'U', label: 'Urgence' },
  { value: 'T', label: 'Médecin traitant' },
  { value: 'N', label: 'Nouveau médecin traitant' },
  { value: 'R', label: 'Médecin traitant de substitution' },
  { value: '0', label: 'Médecin orienté par un médecin traitant' },
  { value: 'M', label: 'Médecin orienté par un autre médecin' },
  { value: 'J', label: 'Généraliste récemment installé' },
  { value: 'B', label: 'Médecin installé en zone sous médicalisée' },
  { value: 'D', label: 'Accès direct spécifique' },
  { value: 'H', label: 'Hors résidence habituelle' },
  { value: 'S1', label: 'Hors accès spécifique' },
  { value: 'S2', label: 'Non-respect du parcours / autre médecin' },
]

export const codeEntentePrealable = [
  { value: 0, label: 'Pas entente' },
  {
    value: 1,
    label: 'Pas reponse',
  },
  {
    value: 2,
    label: 'Favorable',
  },
  {
    value: 3,
    label: 'Urgence',
  },
]

export const BillModes = [
  { value: 0, label: 'Mode Sesam Sans Vitale', requiredCards: [] },
  {
    value: 1,
    label: 'Mode Securise',
    requiredCards: [CardType.CPS, CardType.VITALE],
  },
  { value: 2, label: 'Mode Dégradé', requiredCards: [CardType.CPS] },
  {
    value: 3,
    label: 'Mode Désynchronisé',
    requiredCards: [CardType.CPE, CardType.VITALE],
  },
  { value: 4, label: 'Mode Papier', requiredCards: [] },
]

export const PaymentModeTypeLabels = {
  [PaymentModeType.CASH]: 'Espèces',
  [PaymentModeType.CHEQUE]: 'Chèque',
  [PaymentModeType.CARD]: 'Carte bancaire',
  [PaymentModeType.FREE]: 'Gratuit',
  [PaymentModeType.LOSS_PROFIT]: 'Perte / Profit',
  [PaymentModeType.REDISTRIBUTION]: 'Reversement',
  [PaymentModeType.DEBT_BALANCE]: 'Solde créance',
  [PaymentModeType.BANK_TRANSFER]: 'Virement',
  [PaymentModeType.AMEX]: 'American Express',
}

export const DunningNoticeNextLevel = {
  [DunningNoticeLevel.LEVEL_1]: '1/3',
  [DunningNoticeLevel.LEVEL_2]: '2/3',
  [DunningNoticeLevel.LEVEL_3]: '3/3',
}

export const CashRegisterTransactionTypeLabels = {
  [CashRegisterTransactionType.CLOSE]: 'Fermeture',
  [CashRegisterTransactionType.OPEN]: 'Ouverture',
  [CashRegisterTransactionType.DEBIT]: 'Débit',
  [CashRegisterTransactionType.CREDIT]: 'Crédit',
}

export const MssRequestStatusLabels: Record<MssRequestStatus, string> = {
  [MssRequestStatus.APPROVED]: 'Approuvée',
  [MssRequestStatus.PENDING_DOCTOR_REVIEW]: 'Review médecin',
  [MssRequestStatus.REJECTED]: 'Rejetée',
}

export const MssRequestPriorityLabels: Record<MssRequestPriority, string> = {
  [MssRequestPriority.URGENT]: 'Urgence',
  [MssRequestPriority.NORMAL]: '-15 jours',
  [MssRequestPriority.LOW]: '+15 jours',
  [MssRequestPriority.SPECIFIC]: 'Spécifique (précisez)',
}

export const FileTypeEnumLabels = {
  [FileTypeEnum.PRESCRIPTION]: 'Ordonnance',
  [FileTypeEnum.REPORT]: 'Compte-rendu médical',
  [FileTypeEnum.ID]: 'Document d\'identification',
  [FileTypeEnum.LETTER]: 'Lettre',
  [FileTypeEnum.PREVIOUS_EXAM]: 'Examen précédent',
  [FileTypeEnum.CONSENT]: 'Formulaire de consentement',
  [FileTypeEnum.LABRESULT]: 'Résultat de laboratoire',
  [FileTypeEnum.QUESTIONNAIRE]: 'Questionnaire',
  [FileTypeEnum.EFFORT_TEST]: 'Test d\'effort',
  [FileTypeEnum.CHAT_FILE]: 'Fichier de discussion',
  [FileTypeEnum.SECONDARY_CAPTURE]: 'Capture secondaire',
}

export const MonitoringMethodLabels: Record<MonitoringMethod, string> = {
  [MonitoringMethod.NONE]: 'Aucun',
  [MonitoringMethod.MANUAL]: 'Manuel',
  [MonitoringMethod.DATALOGGER]: 'Datalogger',
  [MonitoringMethod.BMS]: 'GTC',
}

export const StorageTypeLabels: Record<StorageType, string> = {
  [StorageType.ROOM]: 'Pièce',
  [StorageType.FRIDGE]: 'Réfrigérateur',
  [StorageType.FREEZER]: 'Congélateur',
  [StorageType.LAF]: 'PPSL',
  [StorageType.SHIELDED_CABINET]: 'Armoire blindée',
  [StorageType.OTHER]: 'Autre',
}

export const ProductTypeLabels: Record<ProductType, string> = {
  [ProductType.GENERATOR]: 'Générateur',
  [ProductType.KIT]: 'Trousse',
  [ProductType.READY_MADE]: 'Prêt à l\'emploi',
  [ProductType.REAGENT]: 'Réactif',
}

export const SideLabels: Record<Side, string> = {
  [Side.LEFT]: 'Gauche',
  [Side.RIGHT]: 'Droit',
  [Side.MIDLINE]: 'Médian',
  [Side.NA]: 'Non spécifié',
}

export const WasteTypeLabels: Record<WasteType, string> = {
  [WasteType.SOLID]: 'Solide',
  [WasteType.LIQUID]: 'Liquide',
  [WasteType.SHARPS]: 'Aiguilles',
}

export const ActivityLevelLabels: Record<ActivityLevel, string> = {
  [ActivityLevel.NONE]: 'Aucune',
  [ActivityLevel.LOW]: 'Faible',
  [ActivityLevel.HIGH]: 'Élevée',
}

export const WasteStatusLabels: Record<WasteStatus, string> = {
  [WasteStatus.OPEN]: 'Ouvert',
  [WasteStatus.CLOSED]: 'Fermé',
  [WasteStatus.DISPOSED]: 'Éliminé',
}

export const WasteEntrySourceOptions: { value: WasteEntrySource; label: string }[] = [
  { value: 'PREPARATION', label: 'Préparation' },
  { value: 'ELUTION', label: 'Élution' },
  { value: 'MANUAL', label: 'Ajout libre' },
]

export const HotLabEquipmentTypeLabels: Record<HotLabEquipmentType, string> = {
  [HotLabEquipmentType.DOSE_CALIBRATOR]: 'Calibrateur de dose',
  [HotLabEquipmentType.SURVEY_METER]: 'Sonde de mesure',
  [HotLabEquipmentType.GEIGER_COUNTER]: 'Compteur Geiger',
  [HotLabEquipmentType.CONTAMINATION_PROBE]: 'Sonde de contamination',
  [HotLabEquipmentType.LAF]: 'Flux laminaire',
  [HotLabEquipmentType.FRIDGE]: 'Réfrigérateur',
  [HotLabEquipmentType.FREEZER]: 'Congélateur',
  [HotLabEquipmentType.SCALE]: 'Balance',
  [HotLabEquipmentType.ACTIVIMETER]: 'Activimètre',
  [HotLabEquipmentType.PH_METER]: 'pH-mètre',
  [HotLabEquipmentType.TLC_SYSTEM]: 'Chromatographie ITLC/CCM',
  [HotLabEquipmentType.TLC_SCANNER]: 'Scanner radio-TLC',
  [HotLabEquipmentType.GAMMA_SPECTROMETER]: 'Spectromètre gamma',
  [HotLabEquipmentType.OTHER]: 'Autre',
}

export const CompoundTypeLabels: Record<CompoundType, string> = {
  [CompoundType.PURE_ISOTOPE]: 'Isotope pur',
  [CompoundType.READY_TO_USE]: 'Prêt à l\'emploi',
  [CompoundType.TO_PREPARE]: 'À préparer',
}

export const PreparationStatusLabels: Record<PreparationStatus, string> = {
  [PreparationStatus.DRAFT]: 'En cours',
  [PreparationStatus.READY]: 'Prête',
  [PreparationStatus.RELEASED]: 'Libérée',
  [PreparationStatus.REJECTED]: 'Rejetée',
  [PreparationStatus.EXPIRED]: 'Expirée',
}

export const PreparationStatusColors: Record<PreparationStatus, object> = {
  [PreparationStatus.DRAFT]: { color: '#e65100', borderColor: '#ed6c02' },
  [PreparationStatus.READY]: { bgcolor: '#459464', color: '#ffffff', borderColor: '#a5d6a7' },
  [PreparationStatus.RELEASED]: { bgcolor: '#459464', color: '#ffffff', borderColor: '#a5d6a7' },
  [PreparationStatus.REJECTED]: { bgcolor: '#ffebee', color: '#c62828', borderColor: '#ef9a9a' },
  [PreparationStatus.EXPIRED]: { color: 'text.secondary', borderColor: 'rgba(0,0,0,0.26)' },
}

export const QualityControlStatusLabels: Record<QualityControlStatus, string> = {
  [QualityControlStatus.NONE]: 'Aucun contrôle configuré',
  [QualityControlStatus.IN_PROGRESS]: 'En cours',
  [QualityControlStatus.NON_COMPLIANT]: 'Non conforme',
  [QualityControlStatus.COMPLETE]: 'Complet',
}

export const SupplierTypeLabels: Record<SupplierType, string> = {
  [SupplierType.EXTERNAL_ORGANIZATION]: 'Organisme externe',
  [SupplierType.MACHINE_MANUFACTURER]: 'Fabricant machine',
  [SupplierType.PRODUCT_SUPPLIER]: 'Fournisseur produit',
  [SupplierType.SOFTWARE_PUBLISHER]: 'Éditeur de logiciel',
  [SupplierType.OFFICE_SUPPLIER]: 'Bureautique fournisseur',
  [SupplierType.OTHER]: 'Autre',
}

export const SupplierContactTypeLabels: Record<SupplierContactType, string> = {
  [SupplierContactType.COMMERCIAL]: 'Commercial',
  [SupplierContactType.TECHNICIAN]: 'Technicien',
  [SupplierContactType.SALES_ADMINISTRATION]: 'ADV',
  [SupplierContactType.ACCOUNTING]: 'Comptabilité',
  [SupplierContactType.LOGISTICS]: 'Logistique',
  [SupplierContactType.DELIVERY]: 'Livraison',
  [SupplierContactType.OTHER]: 'Autre',
}

export const SupplierPaymentMethodLabels: Record<
  SupplierPaymentMethod,
  string
> = {
  [SupplierPaymentMethod.CHEQUE]: 'Chèque',
  [SupplierPaymentMethod.SEPA_DIRECT_DEBIT]: 'Prélèvement SEPA',
  [SupplierPaymentMethod.TRANSFER]: 'Virement bancaire',
}

export const VisualQualityControlTypeLabels: Record<
  VisualQualityControlType,
  string
> = {
  [VisualQualityControlType.APPEARANCE]: 'Aspect',
  [VisualQualityControlType.COLOR]: 'Couleur',
}

export const CustomQualityControlTypeLabels: Record<
  CustomQualityControlType,
  string
> = {
  [CustomQualityControlType.BOOLEAN]: 'Oui / Non',
  [CustomQualityControlType.LIST]: 'Liste',
  [CustomQualityControlType.TEXT]: 'Textuel',
  [CustomQualityControlType.NUMERIC]: 'Numérique',
}

export const CompoundProductionStepTypeLabels: Record<
  CompoundProductionStepType,
  string
> = {
  [CompoundProductionStepType.BOOLEAN]: 'Oui / Non',
  [CompoundProductionStepType.TEXT]: 'Textuel / Numérique',
  [CompoundProductionStepType.DILUTION]: 'Dilution',
  [CompoundProductionStepType.TIMER]: 'Minuteur',
}

export const WasteContainerEventLabels: Partial<Record<EventEnum, string>> = {
  [EventEnum.WASTE_ENTRY_CREATED]: 'Déchet ajouté',
  [EventEnum.WASTE_ENTRY_COLLECTED]: 'Déchet collecté',
  [EventEnum.WASTE_ENTRY_CANCELLED]: 'Déchet annulé',
  [EventEnum.WASTE_ENTRY_CONTAINER_CHANGED]: 'Déchet déplacé (origine)',
  [EventEnum.WASTE_ENTRY_CONTAINER_CHANGED_RECEIVED]: 'Déchet reçu (déplacement)',
  [EventEnum.WASTE_CONTAINER_CLOSED]: 'Conteneur fermé',
  [EventEnum.WASTE_CONTAINER_REOPENED]: 'Conteneur rouvert',
  [EventEnum.WASTE_CONTAINER_DISPOSED]: 'Conteneur éliminé',
  [EventEnum.WASTE_CONTAINER_DISPOSE_CANCELLED]: 'Élimination annulée',
  [EventEnum.WASTE_CONTAINER_TRANSFERRED]: 'Transvasement effectué',
  [EventEnum.WASTE_CONTAINER_TRANSFER_CREATED]: 'Transvasement initié',
  [EventEnum.WASTE_CONTAINER_TRANSFER_CANCELLED]: 'Transvasement annulé',
  [EventEnum.WASTE_CONTAINER_TRANSFER_RECEIVED]: 'Transvasement reçu',
  [EventEnum.WASTE_CONTAINER_TRANSFER_RECEIVED_CANCELLED]: 'Transvasement reçu annulé',
  [EventEnum.WASTE_CONTAINER_MEASUREMENT_MEASURED]: 'Mesure effectuée',
  [EventEnum.WASTE_CONTAINER_MEASUREMENT_CREATED]: 'Mesure créée',
}

export const ConfigurationEventLabels: Partial<Record<EventEnum, string>> = {
  [EventEnum.CONFIGURATION_CREATED]: 'Création',
  [EventEnum.CONFIGURATION_UPDATED]: 'Modification',
  [EventEnum.ORDER_UPDATED]: 'Ordre modifié',
  [EventEnum.ORDER_DOCUMENT_ADDED]: 'Document ajouté',
  [EventEnum.ORDER_DOCUMENT_REMOVED]: 'Document supprimé',
  [EventEnum.ORDER_RECIPIENT_ADDED]: 'Destinataire ajouté',
  [EventEnum.ORDER_RECIPIENT_REMOVED]: 'Destinataire supprimé',
  [EventEnum.ORDER_COUVERTURE_UPDATED]: 'Couverture modifiée',
  [EventEnum.ORDER_PATIENT_UPDATED]: 'Patient modifié',
  [EventEnum.ORDER_TRANSPORT_CREATED]: 'Transport ajouté',
  [EventEnum.ORDER_TRANSPORT_UPDATED]: 'Transport modifié',
  [EventEnum.ORDER_PRECOTATION_ADDED]: 'Précotation ajoutée',
  [EventEnum.ORDER_PRECOTATION_REMOVED]: 'Précotation supprimée',
}

export const MemberRoleEnumLabels: Record<MemberRoleEnum, string> = {
  [MemberRoleEnum['doctor']]: 'Médecin',
  [MemberRoleEnum['health-executive']]: 'Responsable santé',
  [MemberRoleEnum['executive-director']]: 'Directeur exécutif',
  [MemberRoleEnum['finance-director']]: 'Directeur financier',
  [MemberRoleEnum['accountant']]: 'Comptable',
  [MemberRoleEnum['computer-technician']]: 'Technicien informatique',
  [MemberRoleEnum['security']]: 'Sécurité',
  [MemberRoleEnum['rssi']]: 'RSSI',
  [MemberRoleEnum['dsi']]: 'DSI',
  [MemberRoleEnum['secretary']]: 'Secrétaire',
  [MemberRoleEnum['radiographer']]: 'Radiologue',
  [MemberRoleEnum['service-provider']]: 'Fournisseur de services',
  [MemberRoleEnum['it-provider']]: 'Fournisseur informatique',
  [MemberRoleEnum['manager']]: 'Manager',
  [MemberRoleEnum['radiologist']]: 'Radiologiste',
  [MemberRoleEnum['head-of-emergency']]: 'Chef des urgences',
  [MemberRoleEnum['head-of-radiology']]: 'Chef de la radiologie',
  [MemberRoleEnum['biomedical-engineer']]: 'Ingénieur biomédical',
  [MemberRoleEnum['quality-manager']]: 'Responsable qualité',
  [MemberRoleEnum['other']]: 'Autre',
  [MemberRoleEnum['super_admin']]: 'Super Admin',
}

export const ProductOrderStatusLabels: Record<ProductOrderStatus, string> = {
  [ProductOrderStatus.PENDING_VALIDATION]: 'Attente validation',
  [ProductOrderStatus.PENDING_ORDER_ACKNOWLEDGMENT]: 'Attente ARC',
  [ProductOrderStatus.PENDING_DELIVERY]: 'Attente livraison',
  [ProductOrderStatus.PARTIALLY_RECEIVED]: 'Partiellement reçue',
  [ProductOrderStatus.RECEIVED]: 'Reçue',
  [ProductOrderStatus.CANCELLED]: 'Annulée',
  [ProductOrderStatus.PENDING_MAIL]: 'Attente envoi mail',
  [ProductOrderStatus.MAIL_FAILED]: 'Échec envoi mail',
  [ProductOrderStatus.PENDING_CANCELLATION_MAIL]:
    'Attente envoi mail annulation',
  [ProductOrderStatus.CANCELLATION_MAIL_FAILED]: 'Échec envoi mail annulation',
  [ProductOrderStatus.REJECTED]: 'Rejetée',
  [ProductOrderStatus.RECEIVED_WITH_DISCREPANCIES]: 'Reçue avec deltas',
  [ProductOrderStatus.PENDING_CREDIT_NOTE_MAIL]: 'Attente envoi mail d\'avoir',
  [ProductOrderStatus.CREDIT_NOTE_MAIL_FAILED]: 'Échec envoi mail d\'avoir',
}

export const ProductOrderReceptionStatusRender: Record<
  ProductOrderStatus,
  { color: string; icon: React.ElementType }
> = {
  [ProductOrderStatus.RECEIVED]: {
    color: '#459464',
    icon: CheckCircleIcon,
  },
  [ProductOrderStatus.PARTIALLY_RECEIVED]: {
    color: '#6353aa',
    icon: AdjustIcon,
  },
  [ProductOrderStatus.PENDING_DELIVERY]: {
    color: '#3a92e4',
    icon: LocalShippingIcon,
  },
  [ProductOrderStatus.PENDING_ORDER_ACKNOWLEDGMENT]: {
    color: '#a5a1a6',
    icon: PendingActionsIcon,
  },
  [ProductOrderStatus.PENDING_VALIDATION]: {
    color: '#f59d3a',
    icon: PublishedWithChangesIcon,
  },
  [ProductOrderStatus.CANCELLED]: {
    color: '#e8535b',
    icon: CancelIcon,
  },
  [ProductOrderStatus.PENDING_MAIL]: {
    color: 'grey',
    icon: ForwardToInbox,
  },
  [ProductOrderStatus.MAIL_FAILED]: {
    color: '#2d2d2d',
    icon: Unsubscribe,
  },
  [ProductOrderStatus.PENDING_CANCELLATION_MAIL]: {
    color: 'grey',
    icon: ForwardToInbox,
  },
  [ProductOrderStatus.PENDING_CREDIT_NOTE_MAIL]: {
    color: 'grey',
    icon: ForwardToInbox,
  },
  [ProductOrderStatus.CANCELLATION_MAIL_FAILED]: {
    color: '#2d2d2d',
    icon: Unsubscribe,
  },
  [ProductOrderStatus.CREDIT_NOTE_MAIL_FAILED]: {
    color: '#2d2d2d',
    icon: Unsubscribe,
  },
  [ProductOrderStatus.REJECTED]: {
    color: '#ab2626',
    icon: DoDisturb,
  },
  [ProductOrderStatus.RECEIVED_WITH_DISCREPANCIES]: {
    color: '#459486',
    icon: OfflinePin,
  },
}

export const ProductOrderPaymentStatusLabels: Record<ProductOrderPaymentStatus, string> = {
  [ProductOrderPaymentStatus.PENDING_PAYMENT]: 'À régler',
  [ProductOrderPaymentStatus.PAID]: 'Réglée',
}

export const ProductOrderPaymentStatusRender: Record<
  ProductOrderPaymentStatus,
  { color: string; icon: React.ElementType }
> = {
  [ProductOrderPaymentStatus.PENDING_PAYMENT]: {
    color: '#f59d3a',
    icon: HourglassEmpty,
  },
  [ProductOrderPaymentStatus.PAID]: {
    color: '#459464',
    icon: Paid,
  },
}

export const ProductOrderCancellationReasonLabels: Record<
  ProductOrderCancellationReason,
  string
> = {
  [ProductOrderCancellationReason.INTERNAL_ERROR]: 'Erreur interne',
  [ProductOrderCancellationReason.ORDER_DUPLICATE]: 'Doublon de commande',
  [ProductOrderCancellationReason.OTHER]: 'Autre',
}

export const StockReasonLabels: Record<StockReason, string> = {
  [StockReason.ADJUSTMENT_NEGATIVE]: 'Ajustement négatif',
  [StockReason.ADJUSTMENT_POSITIVE]: 'Ajustement positif',
  [StockReason.CONSUMPTION]: 'Consommation',
  [StockReason.INVENTORY_COUNT]: 'Inventaire',
  [StockReason.RECEIPT]: 'Réception',
  [StockReason.TRANSFER_IN]: 'Transfert entrant',
  [StockReason.TRANSFER_OUT]: 'Transfert sortant',
  [StockReason.WASTE]: 'Déchet',
  [StockReason.RETURN_TO_SUPPLIER]: 'Retour fournisseur',
  [StockReason.EXPIRATION]: 'Expiration',
}

export const StockReasonOperators: Record<StockReason, '+' | '-' | '='> = {
  [StockReason.ADJUSTMENT_NEGATIVE]: '-',
  [StockReason.ADJUSTMENT_POSITIVE]: '+',
  [StockReason.CONSUMPTION]: '-',
  [StockReason.INVENTORY_COUNT]: '=',
  [StockReason.RECEIPT]: '+',
  [StockReason.TRANSFER_IN]: '+',
  [StockReason.TRANSFER_OUT]: '-',
  [StockReason.WASTE]: '-',
  [StockReason.RETURN_TO_SUPPLIER]: '-',
  [StockReason.EXPIRATION]: '-',
}

export const ProductTypeOptions = (
  Object.entries(ProductTypeLabels) as Array<[ProductType, string]>
).map(([value, label]) => ({ label, value }))

export const bankFields: {
  name:
    | 'bankCode'
    | 'branchCode'
    | 'accountNumber'
    | 'controlKey'
    | 'swiftCode'
    | 'countryCode'
  label: string
  placeholder: string
}[] = [
  {
    name: 'countryCode',
    label: 'Code pays',
    placeholder: 'Entrez le code pays',
  },
  {
    name: 'bankCode',
    label: 'Code banque',
    placeholder: 'Entrez le code banque',
  },
  {
    name: 'branchCode',
    label: 'Code agence/guichet',
    placeholder: 'Entrez le code agence/guichet',
  },
  {
    name: 'accountNumber',
    label: 'Numéro de compte',
    placeholder: 'Entrez le numéro de compte',
  },
  {
    name: 'controlKey',
    label: 'Clé de contrôle/RIB',
    placeholder: 'Entrez la clé de contrôle/RIB',
  },
  {
    name: 'swiftCode',
    label: 'Code BIC/Swift',
    placeholder: 'Entrez le code BIC/Swift',
  },
]

export const RELATIONSHIP_LABELS: Record<PatientContactRelationship, string> = {
  [PatientContactRelationship.SPOUSE]: 'Conjoint(e)',
  [PatientContactRelationship.FATHER]: 'Père',
  [PatientContactRelationship.MOTHER]: 'Mère',
  [PatientContactRelationship.SON]: 'Fils',
  [PatientContactRelationship.DAUGHTER]: 'Fille',
  [PatientContactRelationship.BROTHER]: 'Frère',
  [PatientContactRelationship.SISTER]: 'Sœur',
  [PatientContactRelationship.GRANDSON]: 'Petit-fils',
  [PatientContactRelationship.GRANDDAUGHTER]: 'Petite-fille',
  [PatientContactRelationship.UNCLE]: 'Oncle',
  [PatientContactRelationship.AUNT]: 'Tante',
  [PatientContactRelationship.NEPHEW]: 'Neveu',
  [PatientContactRelationship.NIECE]: 'Nièce',
  [PatientContactRelationship.CAREGIVER]: 'Aidant',
  [PatientContactRelationship.OTHER]: 'Autre',
}

export const PrescriptionStatusLabels: Record<PrescriptionStatus, string> = {
  [PrescriptionStatus.PENDING]: 'Attente validation',
  [PrescriptionStatus.VALIDATED]: 'Validée',
}

export const PosologyPatientTypeLabels: Record<PosologyPatientType, string> = {
  [PosologyPatientType.ADULT]: 'Adulte',
  [PosologyPatientType.PREGNANT]: 'Enceinte',
  [PosologyPatientType.CHILD]: 'Enfant',
}

export const PosologySliceTypeLabels: Record<PosologySliceType, string> = {
  [PosologySliceType.MBQ_FIXED]: 'MBq fixe',
  [PosologySliceType.MBQ_PER_KG]: 'MBq/kg',
  [PosologySliceType.EANM]: 'EANM',
}

export const DICTATION_MODE_LABELS: Record<ReportDictationMode, string> = {
  RT_ASR: 'Dictation en temps réel',
  MANUAL: 'Transcription manuelle',
  EH_INFERENCE: 'Inférence Ether Healthcare',
}

export const IsotopeUsageLabels: Record<IsotopeUsage, string> = {
  [IsotopeUsage.DIAGNOSTIC]: 'Diagnostic',
  [IsotopeUsage.TREATMENT]: 'Traitement',
}

export const IsotopeEmissionTypeLabels: Record<IsotopeEmissionType, string> = {
  [IsotopeEmissionType.GAMMA]: 'γ (Photon)',
  [IsotopeEmissionType.BETA_PLUS]: 'β⁺ (Positron)',
  [IsotopeEmissionType.BETA_MINUS]: 'β⁻ (Electron)',
  [IsotopeEmissionType.ALPHA]: 'α (Helium nucleus)',
  [IsotopeEmissionType.ELECTRON_CAPTURE]: 'EC (Electron capture)',
}

export const IsotopeEmissionTypeShortLabels: Record<IsotopeEmissionType, string> = {
  [IsotopeEmissionType.GAMMA]: 'γ',
  [IsotopeEmissionType.BETA_PLUS]: 'β⁺',
  [IsotopeEmissionType.BETA_MINUS]: 'β⁻',
  [IsotopeEmissionType.ALPHA]: 'α',
  [IsotopeEmissionType.ELECTRON_CAPTURE]: 'EC',
}

export const CERCLAGE_COLORS = [
  { color: 'blue',  hex: '#3b82f6' },
  { color: 'green', hex: '#22c55e' },
  { color: 'orange', hex: '#f4874b' },
  { color: 'pink',   hex: '#f472b6' },
  { color: 'purple', hex: '#7c3aed' },
  { color: 'red', hex: '#f94040' },
  { color: 'yellow', hex: '#f5c842' },
  { color: 'black',  hex: '#2d2d2d' },
  { color: 'white',  hex: '#f1f1f1' },
]
